document.addEventListener("DOMContentLoaded", function() {

  // First Order Offer Copy Button
  document.querySelectorAll('.foo-offer__code').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var code = this.getAttribute('data-code');
      navigator.clipboard.writeText(code);

      // Show toast
      var toast = document.getElementById('foo-toast');
      if (toast) {
        toast.classList.add('show');

        setTimeout(function() {
          toast.classList.remove('show');
        }, 2000);
      }
    });
  });

  // Offers Drawer (from product template)
  const trigger = document.querySelector(".view-offers-btn");
  const overlay = document.querySelector(".offers-overlay");
  const closeBtn = document.querySelector(".close-offers");

  if (trigger && overlay && closeBtn) {
    trigger.addEventListener("click", () => {
      overlay.classList.add("active");
    });

    closeBtn.addEventListener("click", () => {
      overlay.classList.remove("active");
    });

    overlay.addEventListener("click", e => {
      if(e.target === overlay){
        overlay.classList.remove("active");
      }
    });

    /* Copy coupon */
    document.querySelectorAll(".copy-btn").forEach(btn => {
      btn.addEventListener("click", () => {
        const code = btn.getAttribute("data-code");
        navigator.clipboard.writeText(code);
        btn.innerText = "Copied!";
        setTimeout(() => {
          btn.innerText = "Copy Code";
        }, 2000);
      });
    });
  }
});
